<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap >
      <v-flex sm12>
        <div class="col-md-12" style="float: right;">
          <v-dialog v-model="modalday.dialog" persistent max-width="50%">
            <v-btn color="primary" dark slot="activator">Filtrar por Data</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline">Escolha a data</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                      label="Data Desejada"
                      type="date"
                      v-model="dayStart"
                      required autofocus></v-text-field>
                    </v-flex>                    
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="updateFilter()">Buscar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-flex>

      <v-flex lg12>
        <vue-good-table
        :columns="columns"
        :rows="filteredAgendamentos"
        @on-cell-click="onCellClick"
        :pagination-options="{
        enabled: true,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Registros por página',
        ofLabel: 'of',
        allLabel: 'Todos',
      }"
      styleClass="vgt-table bordered vgt-table condensed">
    </vue-good-table>
  </v-flex>

</v-layout>
</v-container>
</template>

<script>
import {http, httpLogin} from '../../backend/vue-axios/axios';
import swal from 'sweetalert';
import { mapGetters } from 'vuex';
export default {
  data () {
    return {
      file: '',
      search: '',
      schedules: [],
      dados_trainings: [],
      columns: [
      {
        label: 'Colaborador',
        field: 'employee.name',
        filterOptions: {
          enabled: true,
          placeholder: 'Informe o nome do colaborador', 
          filterDropdownItems: [],
          filterFn: this.columnFilterFn, 
        },
      },      
      {
        label: 'Consulta/Tipo',
        field: 'schedule_type.name',
      },      
      {
        label: 'Empresa',
        field: 'employee.company.name',
        filterOptions: {
          enabled: true,
          placeholder: 'Informe o nome da Empresa', 
          filterDropdownItems: [],
          filterFn: this.columnFilterFn, 
        },
      },
      {
        label: 'Data',
        field: 'date',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DD',
        dateOutputFormat: 'DD/MM/YYYY',
      },
      {
        label: 'Exames Complementares',
        field: 'complement',
      },      
      {
        label: 'Audiometria',
        field: this.fieldAudiomentria,
      },      
      {
        label: 'Eletrocardiograma',
        field: this.fieldEletro,
      },      
      {
        label: 'Espirometria',
        field: this.fieldEspirometria,
      },      
      {
        label: 'Psicosocial',
        field: this.fieldPsico,
      },      
      {
        label: 'Raio X',
        field: this.fieldRaiox,
      },      
      {
        label: 'Exames de sangue',
        field: this.fieldFnSangue,
      },


      ],
      dayStart: '',
      modalday: {
        dialog: false
      },
    };
  },

  computed: {
    filteredAgendamentos: function() {

      var date = this.dayStart;

      if(date == "") {
        return this.schedules;
      } else {
        return this.schedules.filter(function(agendamento) {
          return agendamento.date == date;
        });
      }
    }
  },

  mounted () {
    this.buscaAgendamentos();
  }, 

  methods: {

    fieldFnSangue(rowObj) {
      if (rowObj.sangue == 1) {
        return 'Soliciado'
      } else {
        return 'Não Soliciado'
      }
    },    

    fieldRaiox(rowObj) {
      if (rowObj.raiox == 1) {
        return 'Soliciado'
      } else {
        return 'Não Soliciado'
      }
    },    

    fieldPsico(rowObj) {
      if (rowObj.psicosocial == 1) {
        return 'Soliciado'
      } else {
        return 'Não Soliciado'
      }
    },    

    fieldEspirometria(rowObj) {
      if (rowObj.espirometria == 1) {
        return 'Soliciado'
      } else {
        return 'Não Soliciado'
      }
    },    

    fieldEletro(rowObj) {
      if (rowObj.eletrocardiograma == 1) {
        return 'Soliciado'
      } else {
        return 'Não Soliciado'
      }
    },    
    fieldAudiomentria(rowObj) {
      if (rowObj.audiometria == 1) {
        return 'Soliciado'
      } else {
        return 'Não Soliciado'
      }
    },

    onCellClick(params)
    {

      if(params.column.field == 'btncertificado')
      {
        this.clickAddCertficado(params)
      }else{
        this.clickTd(params)
      } 

    },

    buscaAgendamentos() {
      http.get('schedules')
      .then(response => {
       this.schedules = response.data;

       for (var traning in this.trainings) {
        this.trainings[traning].btn = '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--outline v-btn--depressed v-btn--small theme--dark primary--text" style="position: relative;"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons">edit</i></div></button>'
        this.trainings[traning].btncertificado = '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--outline v-btn--depressed v-btn--small theme--dark primary--text" style="position: relative;"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons">assignment</i></div></button>'
      }
    })
      .catch(error => {
      });
    },

    updateFilter() {
     this.modalday.dialog = false
    }
  }
};
</script>
<style scoped lang="css">
</style>



// WEBPACK FOOTER //
// src/components/agendamentos/Agendamentos.vue